var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPriceTagOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  viewBox: "0 0 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M17.86 0h-7.286c-.302 0-.592.12-.806.334L.334 9.769a1.14 1.14 0 0 0 0 1.612l7.285 7.286a1.141 1.141 0 0 0 1.612 0l9.435-9.436c.214-.213.334-.503.334-.806V1.14C18.999.51 18.489 0 17.86 0Zm.38 8.425c0 .101-.04.197-.112.269l-9.434 9.435a.38.38 0 0 1-.537 0L.87 10.844a.38.38 0 0 1 0-.537L10.306.87a.378.378 0 0 1 .268-.111h7.286c.21 0 .38.17.38.38v7.285ZM14.06 3.04a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8Zm0 3.04a1.14 1.14 0 1 1 0-2.28 1.14 1.14 0 0 1 0 2.28Z"
})));
export default SvgPriceTagOutline;